import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { classNames } from "@via/utils/helpers.tsx";
import { type JSX } from "react";
import "./action-button.css";

export const ActionButton = ({
  id = "",
  button,
  onClick,
  disabled = false,
  primary = true,
  showIcon = true,
  icon: Icon = PlusCircleIcon,
  title,
  className,
}: {
  id?: string;
  /** Extra classes for the button, e.g. to keep it on one line in a narrow cell. */
  className?: string;
  /** Shown on hover, e.g. why the button is disabled. */
  title?: string;
  button: string;
  onClick?: () => void;
  disabled?: boolean;
  primary?: boolean;
  showIcon?: boolean;
  icon?: typeof PlusCircleIcon;
}): JSX.Element => {
  const buttonId = (id.length > 0 ? id : button)
    .toLowerCase()
    .split(" ")
    .join("-");

  return (
    <button
      id={`action-button-${buttonId}`}
      type="button"
      disabled={disabled}
      title={title}
      onClick={onClick}
      className={classNames(
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        primary
          ? "bg-indigo-600 text-white hover:bg-indigo-500 hover:shadow-md"
          : "mr-4 border-[1px] border-gray-300 bg-white text-gray-600 hover:shadow-md",
        "inline-flex gap-x-1.5 rounded-md px-3 py-2 text-sm shadow-sm duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
        className ?? ""
      )}>
      {showIcon && <Icon className="-ml-0.5 h-5 w-5" aria-hidden="true" />}
      {button}
    </button>
  );
};
